import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  CreateCigarProductionPlan,
  DeleteCigarProductionPlan,
  GetCigarProductionPlans,
  UpdateCigarProductionPlan,
  TakeInWorkCigarProductionPlan,
  GetCigarProductionPlanSummaries,
} from './thunks';
import {
  CreateCigarProductionPlanReducer,
  DeleteCigarProductionPlanReducer,
  GetCigarProductionPlansReducer,
  ResetCigarProductionPlansStateReducer,
  UpdateCigarProductionPlanReducer,
  TakeInWorkCigarProductionPlanReducer,
  GetCigarProductionPlanSummariesReducer,
} from './reducers';

// ----------------------------------------------------------------------------

export const slice = createSlice({
  name: 'cigarProductionPlans',
  initialState,
  reducers: {
    ResetCigarProductionPlansState: ResetCigarProductionPlansStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetCigarProductionPlans, GetCigarProductionPlansReducer);
    addExtraReducer(builder, GetCigarProductionPlanSummaries, GetCigarProductionPlanSummariesReducer);
    addExtraReducer(builder, CreateCigarProductionPlan, CreateCigarProductionPlanReducer);
    addExtraReducer(builder, UpdateCigarProductionPlan, UpdateCigarProductionPlanReducer);
    addExtraReducer(builder, DeleteCigarProductionPlan, DeleteCigarProductionPlanReducer);
    addExtraReducer(builder, TakeInWorkCigarProductionPlan, TakeInWorkCigarProductionPlanReducer);
  },
});

export default slice.reducer;
